import type { CancelablePromise } from "@/client"
import { OpenAPI } from "@/client"
import { request as __request } from "@/client/core/request"

export interface QuestionAuditLogChange {
  field: string
  old: unknown
  new: unknown
}

export interface QuestionAuditActor {
  id: string | null
  email: string | null
  full_name: string | null
}

export interface QuestionAuditLogEntry {
  id: string
  action: string
  actor: QuestionAuditActor | null
  changes: QuestionAuditLogChange[]
  created_at: string
}

export const getQuestionAuditLog = (
  questionId: string,
): CancelablePromise<QuestionAuditLogEntry[]> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/api/v1/questions/{question_id}/audit-log",
    path: {
      question_id: questionId,
    },
  })
}
